import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemeService } from 'src/app/services/client/theme/theme.service';

@Component({
  selector: 'app-support-modal',
  templateUrl: './support-modal.component.html',
  styleUrls: ['./support-modal.component.scss'],
})
export class SupportModalComponent {
  @Input() showModal = false;
  @Input() showPnrInfo = true;
  @Input() customInfoText = '';
  @Output() closeModal = new EventEmitter<void>();

  constructor(public theme: ThemeService) {}

  onOverlayClick() {
    this.closeModal.emit();
  }

  onCloseClick() {
    this.closeModal.emit();
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
}
